'use client';
import { getValidChildren } from '@chakra-ui/utils/children';
import { createElement } from 'react';
import { useTabsContext, TabContentProvider } from './tabs-context.mjs';
import { makeTabPanelId, makeTabId } from './use-tabs.mjs';

function useTabContentGroup(props) {
  const context = useTabsContext();
  const { id, selectedIndex } = context;
  const validChildren = getValidChildren(props.children);
  const children = validChildren.map(
    (child, index) => createElement(
      TabContentProvider,
      {
        key: index,
        value: {
          isSelected: index === selectedIndex,
          id: makeTabPanelId(id, index),
          tabId: makeTabId(id, index),
          selectedIndex
        }
      },
      child
    )
  );
  return { ...props, children };
}

export { useTabContentGroup };
